export const ACTION_TYPE_PROGRESSTRACK = {
  GET_SIGNUP_ADD_CHILD: 'GET_SIGNUP_ADD_CHILD',
  GET_ALERT_CONTENT: 'GET_ALERT_CONTENT',
  DELETE_ALERT: 'DELETE_ALERT',
}
